export default __webpack_public_path__ + "static/media/miguel-lopes-20.7fb81c2e.jpg";